// Wrapper de API do onboarding de embarcador (PO1-2428, épico PO1-2427).
// Backend: backend_hub, módulo onboarding. Todas as rotas são admin Everlog.

import api from "./api";

export async function consultarCnpj(cnpj) {
  const { data } = await api.get(`/onboarding/cnpj/${cnpj}`);
  return data;
}

// PO1-2897: lista de onboardings. params: status (pendente|concluido|todos,
// default pendente), q (nome ou CNPJ), page, pageSize, sort, dir.
// Resposta { items, count, page, pageSize } com count = total do recorte.
export async function listEmbarcadores(params = {}) {
  const { data } = await api.get("/onboarding/embarcadores", { params });
  return data;
}

export async function criarEmbarcador(payload) {
  const { data } = await api.post("/onboarding/embarcadores", payload);
  return data;
}

export async function getEmbarcador(id) {
  const { data } = await api.get(`/onboarding/embarcadores/${id}`);
  return data;
}

export async function atualizarIdentidade(id, payload) {
  const { data } = await api.put(
    `/onboarding/embarcadores/${id}/identidade`,
    payload
  );
  return data;
}

export async function adicionarFilial(id, payload) {
  const { data } = await api.post(
    `/onboarding/embarcadores/${id}/filiais`,
    payload
  );
  return data;
}

export async function removerFilial(id, idFilial) {
  const { data } = await api.delete(
    `/onboarding/embarcadores/${id}/filiais/${idFilial}`
  );
  return data;
}

export async function convidarUsuarios(id, usuarios) {
  const { data } = await api.post(`/onboarding/embarcadores/${id}/usuarios`, {
    usuarios,
    baseUrl: window.location.origin,
  });
  return data;
}

export async function listConvites(id) {
  const { data } = await api.get(`/onboarding/embarcadores/${id}/usuarios`);
  return data;
}

export async function listTransportadoras(id) {
  const { data } = await api.get(
    `/onboarding/embarcadores/${id}/transportadoras`
  );
  return data;
}

export async function adicionarTransportadora(id, payload) {
  const { data } = await api.post(
    `/onboarding/embarcadores/${id}/transportadoras`,
    payload
  );
  return data;
}

// PO1-2660: template único versionado no repo do backend_hub. Retorna o
// blob puro — quem chama monta o download (URL.createObjectURL).
export async function baixarPlanilhaModelo() {
  const { data } = await api.get("/onboarding/planilha-modelo", {
    responseType: "blob",
  });
  return data;
}

// PO1-2658: confirma/edita o apelido pendente de revisão e libera o passo
// Local Arquivo para esta transportadora.
export async function revisarApelidoTransportadora(id, idTransportadora, apelido) {
  const { data } = await api.put(
    `/onboarding/embarcadores/${id}/transportadoras/${idTransportadora}/apelido`,
    { apelido }
  );
  return data;
}

// PO1-2746: dispara o e-mail ao sponsor com a planilha anexada + link
// tokenizado de upload; reenvio invalida o link anterior.
export async function enviarKitSponsor(id, { sponsorNome, sponsorEmail }) {
  const { data } = await api.post(`/onboarding/embarcadores/${id}/kit-sponsor`, {
    sponsorNome,
    sponsorEmail,
    baseUrl: window.location.origin,
  });
  return data;
}

// PO1-2896: arquivos recebidos pelo link do kit, direto do SFTP
// (<Apelido>/ONBOARDING/{planilha,base-movimento,tabelas}). Só leitura.
// Resposta { pasta, total, campos: [{ campo, rotulo, pasta, arquivos: [{ nome,
// tamanho, modificadoEm }] }] }; 503 quando o SFTP está fora.
export async function listKitArquivos(id) {
  const { data } = await api.get(`/onboarding/embarcadores/${id}/kit/arquivos`);
  return data;
}

// Blob puro; quem chama monta o download (utils/downloadBlob). `campo` é uma
// das 3 pastas (planilha | base-movimento | tabelas).
export async function downloadKitArquivo(id, campo, nome) {
  const { data } = await api.get(
    `/onboarding/embarcadores/${id}/kit/arquivos/download`,
    { params: { campo, nome }, responseType: "blob" }
  );
  return data;
}

export async function downloadKitZip(id) {
  const { data } = await api.get(
    `/onboarding/embarcadores/${id}/kit/arquivos/zip`,
    { responseType: "blob" }
  );
  return data;
}

export async function importarPlanilha(id, file) {
  const formData = new FormData();
  formData.append("planilha", file);
  const { data } = await api.post(
    `/onboarding/embarcadores/${id}/importar-planilha`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}

export async function getCredenciais(id) {
  const { data } = await api.get(`/onboarding/embarcadores/${id}/credenciais`);
  return data;
}

export async function emitirCredenciais(id) {
  const { data } = await api.post(
    `/onboarding/embarcadores/${id}/credenciais`
  );
  return data;
}

export async function homologar(id, payload) {
  const { data } = await api.post(
    `/onboarding/embarcadores/${id}/homologar`,
    payload
  );
  return data;
}

export async function getParametros(id) {
  const { data } = await api.get(`/onboarding/embarcadores/${id}/parametros`);
  return data;
}

export async function aplicarParametros(id, payload) {
  const { data } = await api.post(
    `/onboarding/embarcadores/${id}/parametros`,
    payload
  );
  return data;
}

export async function getFiscal(id) {
  const { data } = await api.get(`/onboarding/embarcadores/${id}/fiscal`);
  return data;
}

export async function semearFiscal(id, payload) {
  const { data } = await api.post(
    `/onboarding/embarcadores/${id}/fiscal`,
    payload
  );
  return data;
}

export async function listLocaisArquivo(id) {
  const { data } = await api.get(
    `/onboarding/embarcadores/${id}/local-arquivo`
  );
  return data;
}

export async function provisionarLocalArquivo(id, payload) {
  const { data } = await api.post(
    `/onboarding/embarcadores/${id}/local-arquivo`,
    payload
  );
  return data;
}

export async function listProdutos(id) {
  const { data } = await api.get(`/onboarding/embarcadores/${id}/produtos`);
  return data;
}

export async function definirProdutos(id, codigos) {
  const { data } = await api.put(`/onboarding/embarcadores/${id}/produtos`, {
    codigos,
  });
  return data;
}
